
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[urlFriendlyName]",
      function () {
        return require("private-next-pages/blog/[urlFriendlyName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[urlFriendlyName]"])
      });
    }
  